<script lang="ts">
import { defineComponent } from '@mimir/web/compat/vueCompat';
import { VCol, VCombobox, VRow } from 'vuetify/lib';

export default defineComponent({
  name: 'MCombobox',
  components: {
    VCol,
    VCombobox,
    VRow,
  },
  inheritAttrs: false,
  props: {
    label: {
      type: String,
    },
    highContrast: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isFocused: false,
    };
  },
  methods: {
    activateMenu() {
      if (this.$refs.select) {
        (this.$refs.select as any).activateMenu();
      }
    },
  },
});
</script>

<template>
  <VRow
    no-gutters
    class="profile-row"
  >
    <VCol
      v-if="label"
      cols="12"
      :class="['profile-label', isFocused && 'focused']"
    >
      <span
        v-if="!$scopedSlots['infotext']"
        :class="[highContrast && 'high-contrast']"
        v-text="label"
      />
      <InfoBubble v-else>
        <span
          :class="[highContrast && 'high-contrast']"
          v-text="label"
        />
        <template #infotext>
          <slot name="infotext" />
        </template>
      </InfoBubble>
    </VCol>
    <VCol cols="12">
      <VCombobox
        ref="select"
        class="m-select m-common"
        hide-details="auto"
        v-bind="$attrs"
        dense
        solo
        :loader-height="1"
        :menu-props="$attrs['menu-props'] || { offsetY: true }"
        v-on="$listeners"
        @focus="isFocused = true"
        @blur="isFocused = false"
      >
        <template
          v-for="(_, scopedSlotName) in $scopedSlots"
          #[scopedSlotName]="slotData"
        >
          <slot
            :name="scopedSlotName"
            v-bind="slotData"
          />
        </template>
        <template
          v-for="(_, slotName) in $slots"
          #[slotName]
        >
          <slot :name="slotName" />
        </template>
      </VCombobox>
    </VCol>
  </VRow>
</template>

<style lang="stylus" scoped>
:deep(.v-text-field__details)
  padding: 0px !important

</style>
